<div class="simulator-visual">
  <span class="image-label">{{ imageLabel }}</span>
  <div class="image-wrapper" [class.initial-image]="!thumbnailUrl">
    <div class="left-column">
      @if (showPorosity) {
        <div class="porosity">
          <span class="porosity-label">{{ porosityLabel }}</span>
          <span class="porosity-value">{{ totalPorosity }}</span>
        </div>
      }
    </div>
    
    <div class="image-placeholder" [style.background-image]="thumbnailUrl ? 'url(' + thumbnailUrl + ')' : null"></div>
    
    <div class="right-column">
      @if (showAdditionalInfo && additionalInfoValue) {
        <div class="additional-info">
          <span class="additional-info-label">{{ additionalInfoLabel }}</span>
          <span class="additional-info-value">{{ additionalInfoValue }}</span>
        </div>
      }
      
      @if (thumbnailUrl && showLegend) {
        <div class="legend">
          <div class="legend-item">
            <div class="legend-square pore"></div>
            <span>Pore</span>
          </div>
          <div class="legend-item">
            <div class="legend-square rock"></div>
            <span>Rock</span>
          </div>
        </div>
      }
    </div>
  </div>
</div>
